import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "util--screen-reader" }
const _hoisted_2 = { class: "content-grid" }

import {useI18n} from "vue3-i18n"
import {useMemberStore} from "@/stores/memberStore";
import MemberOrganizationForm from "@/views/member/MemberOrganizationForm.vue";
import IndividualMemberSyndicateView from "@/views/member/IndividualMemberSyndicateView.vue";
import SyndicateCoownerOrganizationView from "@/views/member/SyndicateCoownerOrganizationView.vue";
import {Role} from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SyndicateIndex',
  setup(__props) {

const {t} = useI18n()
const memberStore = useMemberStore()
const member = memberStore.getMember;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)("routes.syndicate.name")), 1),
    _createElementVNode("div", _hoisted_2, [
      (_unref(memberStore).hasIndividualAndCoOwnerRoles())
        ? (_openBlock(), _createBlock(IndividualMemberSyndicateView, { key: 0 }))
        : (_unref(memberStore).hasRole(_unref(Role).RegularSyndicateCoOwner))
          ? (_openBlock(), _createBlock(SyndicateCoownerOrganizationView, {
              key: 1,
              "organization-id": _unref(member).organizationId
            }, null, 8, ["organization-id"]))
          : (_openBlock(), _createBlock(MemberOrganizationForm, {
              key: 2,
              "organization-id": _unref(member).organizationId
            }, null, 8, ["organization-id"]))
    ])
  ]))
}
}

})